import { ReduxUtils } from '../../../dependencies';
import types from '../../actionTypes';

const actionTypes = {
    REQUEST: types.UPDATE_TAG_REQUEST,
    SUCCESS: types.UPDATE_TAG_SUCCESS,
    FAILURE: types.UPDATE_TAG_FAILURE,
    CANCEL: types.UPDATE_TAG_CANCEL,
};

const basicReducer = ReduxUtils.basicApiReducer({
    actionTypes,
});

export default ReduxUtils.containerReducer({
    childReducer: basicReducer,
    actionTypes: Object.values(actionTypes),
    selectors: {
        itemId: action => action.meta.id,
    },
});
